import IImage from '@/interfaces/IImage';

const escapeRegExp = (str: string): string => {
  return str.replace(/[.*+?^=!:${}()|\[\]\/\\]/g, '\\$&'); // Escape special characters in the string
};

// Function to get images starting with "//"
function getImagesStartingWithDoubleSlash(images: IImage[]): string[] {
  return images
    .filter((image) => image.src.startsWith('//')) // Filter images that start with //
    .map((image) => image.src); // Get the src (URL) of each image
}

// Function to update descriptionHtml with "https:" for images starting with "//"
function updateDescriptionHtmlWithHttps(
  descriptionHtml: string,
  imagesStartingWithDoubleSlash: string[]
): string {
  imagesStartingWithDoubleSlash.forEach((imageSrc) => {
    // Create a regular expression to match the src in descriptionHtml
    const escapedSrc = escapeRegExp(imageSrc);
    const regex = new RegExp(`src="(${escapedSrc})"`, 'g');
    // Replace src with the updated URL (https:)
    descriptionHtml = descriptionHtml.replace(regex, (match, p1) =>
      match.replace(p1, `https:${p1}`)
    );
    const urlRegex = new RegExp(`url\\(["']?(${escapedSrc})["']?\\)`, 'g');
    descriptionHtml = descriptionHtml.replace(urlRegex, (match, p1) =>
      match.replace(p1, `https:${p1}`)
    );
  });

  return descriptionHtml;
}

function getImagesStartingWithSingleSlash(images: IImage[]): string[] {
  return images
    .filter((image) => image.src.startsWith('/') && !image.src.startsWith('//')) // Ensure it's a single slash
    .map((image) => image.src);
}

function updateDescriptionHtmlWithBaseUrl(
  descriptionHtml: string,
  imagesStartingWithSingleSlash: string[],
  baseURL: string
): string {
  imagesStartingWithSingleSlash.forEach((imageSrc) => {
    const escapedSrc = escapeRegExp(imageSrc);
    const regex = new RegExp(`src="(${escapedSrc})"`, 'g');
    descriptionHtml = descriptionHtml.replace(regex, (match, p1) =>
      match.replace(p1, `${baseURL}${p1}`)
    );
    const urlRegex = new RegExp(`url\\(["']?(${escapedSrc})["']?\\)`, 'g');
    descriptionHtml = descriptionHtml.replace(urlRegex, (match, p1) =>
      match.replace(p1, `${baseURL}${p1}`)
    );
  });

  return descriptionHtml;
}

function fixImageSrc(image: IImage): IImage {
  return {
    ...image,
    src: image.src.startsWith('//') ? `https:${image.src}` : image.src,
  };
}

function fixImageRelativeSrc(image: IImage, baseURL: string): IImage {
  return {
    ...image,
    src:
      image.src.startsWith('/') && !image.src.startsWith('//')
        ? `${baseURL}${image.src}`
        : image.src,
  };
}

export default {
  getImagesStartingWithDoubleSlash,
  updateDescriptionHtmlWithHttps,
  getImagesStartingWithSingleSlash,
  updateDescriptionHtmlWithBaseUrl,
  fixImageSrc,
  fixImageRelativeSrc,
};
